import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { templateCharCountStyle } from './char-count/template-char-count.style';
import { templateEditorTheme } from './editor/template-editor-theme';
import { TemplateEditorStyleProps, templateEditorStyle } from './editor/template-editor.style';
import { templatePreviewStyle } from './preview/template-preview.styles';
import { messageTemplateTagTheme } from './tags/message-template-tag-theme';
import { messageTemplateTagStyle } from './tags/message-template-tag.style';
import { MessageTemplateTagStyleProps } from './tags/types';

const xIconStyle = css`
  color: ${theme.colors.neutral20};
  margin-left: ${theme.spacing(0.5)};
`;

const linkStyle = css`
  color: ${theme.colors.primary50};
`;

export const MessageTemplateStyles = {
  templateEditor: (props: TemplateEditorStyleProps) => templateEditorStyle(templateEditorTheme, props),
  templateCharCount: templateCharCountStyle,
  templatePreview: templatePreviewStyle,
  messageTemplateTag: (props: MessageTemplateTagStyleProps) => messageTemplateTagStyle(messageTemplateTagTheme, props),
  xIconStyle,
  linkStyle,
};
